/**
 * author: Alex Lai
 * Support Website: https://laialex.com
 * Email: alex@laialex.com
 * Create Time: 2024/9/12
 */
import React, { Component } from 'react'
import * as ui from 'antd'
import apis from '../../../../utils/apis'
import { BellOutlined } from '@ant-design/icons'
import { PageHeader } from '@ant-design/pro-layout';
import HttpPost from '../../../../utils/request'
import dayjs from 'dayjs'


const { TextArea } = ui.Input
const { Option } = ui.Select

export default class Channels extends Component {
  constructor() {
    super()
    this.state = {
      tableData: [],
      paging: { total: 0, pageNumber: 1, pageSize: 20 },
      tableLoad: false,
      searchKey: {},
      editShow: false,
      editCurr: {},
      submitting: false,
      availableAuthorize: []
    }
  }

  componentDidMount() {
    this.availableAuthorizeSync()
    this.tableDataSync(1)
  }

  /**
   * 加载执行分组
   */
  availableAuthorizeSync() {
    var param = {}
    param.pageNumber = 1
    param.pageSize = 2000
    param.code = 'channel'
    param.service = 'MsgBot'
    var that = this
    apis.systemConfigureAuthorizes(param).then(res => {
      that.setState({
        availableAuthorize: res.data.data.data
      })
    })
  }

  subChanenls(){
    return {
      Pushplus: [
        [
          {
            "key": "wechat",
            "name": "微信公众号渠道",
            "desc": "免费"
          },
          {
            "key": "webhook",
            "name": "第三方webhook渠道",
            "desc": "免费；支持企业微信、钉钉、飞书、bark、Gotify、腾讯轻联、集简云、server酱、IFITT、WxPusher、自定义"
          },
          {
            "key": "cp",
            "name": "企业微信应用渠道",
            "desc": "免费"
          },
          {
            "key": "mail",
            "name": "邮箱渠道",
            "desc": "免费"
          },
          {
            "key": "sms",
            "name": "短信渠道",
            "desc": "收费；成功发送1条短信需要10积分（0.1元）"
          },
          {
            "key": "voice",
            "name": "语音渠道",
            "desc": "收费；接通1次语音呼叫需要30积分（0.3元）"
          },
          {
            "key": "extension",
            "name": "插件渠道",
            "desc": "免费；支持浏览器扩展插件和桌面应用程序"
          },
          {
            "key": "app",
            "name": "App渠道",
            "desc": "免费；支持安卓、鸿蒙、iOS系统"
          }
        ]
      ]
    }
  }

  getSubChannel(){
    var that = this
    if (!that.state.editCurr.authorize_channel_id) {
      return null
    }
    var channels = that.state.availableAuthorize.filter(item => item.id == that.state.editCurr.authorize_channel_id)
    if (channels.length == 0) {
      return null
    }
    return that.subChanenls()[channels[0].grant.code]
  }

  /**
   * 发起搜索
   * @param params
   * @constructor
   */
  makeSearch = (params) => {
    this.setState({
      searchKey: params
    })
    var that = this
    setTimeout(function() {
      that.tableDataSync()
    }, 200)
  }
  /**
   * 签名列表
   * @param pageNumber
   Object.assign(para, that.state.keywords)
   * @param pageSize
   * @constructor
   */
  tableDataSync = (pageNumber = 1) => {
    let that = this
    let para = {}
    para.pageNumber = pageNumber
    para.pageSize = 20
    that.setState({
      tableLoad: true
    })
    Object.assign(para, that.state.searchKey)
    apis.messagePushChannelList(para).then(function(resp) {
      that.setState({
        tableLoad: false
      })
      var curr = {
        total: resp.data.data.total,
        pageNumber: pageNumber
      }
      that.setState({
        tableData: resp.data.data.data,
        paging: curr
      })
    })
  }

  render() {
    var that = this

    const columns = [
      {
        title: 'ID',
        dataIndex: 'id'
      },
      {
        title: '通道名称',
        key: 'id',
        render: function(value, row, index) {
          return row.name
        }
      },
      {
        title: '授权节点',
        key: 'id',
        render: function(value, row, index) {
          return <ui.Button shape={'round'}>{row.authorize_channel.name}</ui.Button>
        }
      },
      {
        title: '创建时间',
        key: 'id',
        render: function(value, row, index) {
          return dayjs(row.created_time).format('YYYY-MM-DD HH:mm:ss')
        }
      },
      {
        title: '可用',
        key: 'id',
        render: function(value, row, index) {
          return (
            <ui.Button shape={'circle'} size={'small'} type={'primary'} danger={true}>{row.state ? '是' : '否'}</ui.Button>
          )
        }
      },
      {
        title: '管理',
        key: 'id',
        fixed: 'right',
        render: function(value, row, index) {
          return (
            <span>
                 <ui.Button onClick={() => {
                   var data = JSON.parse(JSON.stringify(row))
                   data.authorize_channel_id = data.authorize_channel.id
                   that.setState({
                     editCurr: data,
                     editShow: true
                   })
                 }} type={'link'}>编辑</ui.Button>
            </span>
          )
        }
      }
    ]




    return (
      <div>
        <PageHeader title="消息推送通道管理" subTitle="配置消息统一推送通道" extra={[
          <ui.Button key="1" type="primary" shape="round" onClick={() => {
            that.setState({
              editCurr: {},
              editShow: true,
              submitting: false
            })
          }}>注册新通道</ui.Button>
        ]} />
        <div style={{ color: 'darkcyan', fontSize: '10px', marginBottom: '16px' }}>
          <BellOutlined /> 免费用户可配置两个消息推送通道，付费用户可配置多个消息推送通道
        </div>
        <ui.Card>
          <div style={{ marginTop: '22px' }}>
            <ui.Form onFinish={that.makeSearch} layout={'inline'}>
              <ui.Form.Item label={'通道名称'} name={'name__contains'}>
                <ui.Input placeholder={'通道名称'} />
              </ui.Form.Item>
              <ui.Form.Item>
                <ui.Button type={'primary'} htmlType={'submit'}>快速搜索</ui.Button>
              </ui.Form.Item>
            </ui.Form>
          </div>
        </ui.Card>

        <div style={{ marginTop: '22px' }}>
          <ui.Table
            rowKey="id"
            dataSource={this.state.tableData}
            columns={columns}
            loading={this.state.tableLoad}
            pagination={{
              total: this.state.paging.total,
              defaultPageSize: 20,
              defaultCurrent: this.state.paging.pageNumber,
              onChange: this.tableDataSync
            }} />
        </div>

        <ui.Modal open={that.state.editShow} title={'定时任务推送通道名称'} onCancel={() => {
          that.setState({
            editCurr: {},
            editShow: false,
            submitting: false
          })
        }} footer={null} destroyOnClose>
          <ui.Form onFinish={(params => {
            that.setState({
              submitting: true
            })
            if (that.state.editCurr.id) {
              params.id = that.state.editCurr.id
            }
            apis.messagePushChannelModify(params).then(resp => {
              that.setState({
                submitting: false
              })
              if (resp.data.code === 200) {
                ui.message.success('提交信息成功')
                that.tableDataSync(that.state.editCurr.id ? that.state.paging.pageNumber : 1)
                that.setState({
                  submitting: false,
                  editShow: false,
                  editCurr: {}
                })
              } else {
                ui.message.error(resp.data.msg)
              }
            })
          })} labelCol={{ span: 24 }} labelAlign={'left'} initialValues={that.state.editCurr}>
            <ui.Form.Item label={'推送通道名称'} name={'name'}
                          rules={[{ required: true, message: '推送通道名称' }]}>
              <ui.Input placeholder={'推送通道名称'} />
            </ui.Form.Item>
            <ui.Form.Item label={'授权终端'} name={'authorize_channel_id'} rules={[{ required: true, message: '授权终端' }]}>
              <ui.Select  disabled={that.state.editCurr.id && !that.state.editCurr.authorize_channel_id} placeholder={'授权终端'} style={{ width: '100%' }}>
                {that.state.availableAuthorize.map(item => {
                  return (
                    <Option value={item.id} key={item.id}>{item.name}</Option>
                  )
                })}
              </ui.Select>
            </ui.Form.Item>
            <ui.Form.Item label={'推送通道状态'} name={'state'}
                          rules={[{ required: true, message: '推送通道状态' }]}>
              <ui.Radio.Group>
                <ui.Radio value={true}>可用</ui.Radio>
                <ui.Radio value={false}>禁用</ui.Radio>
              </ui.Radio.Group>
            </ui.Form.Item>
            {that.getSubChannel() &&
            <ui.Form.Item label={'推送通道'} name={'sub_channel'}
                          rules={[{ required: true, message: '推送通道' }]}>
              <ui.Select placeholder={'推送通道'} style={{ width: '100%' }}>
                {that.getSubChannel().map(item => {
                  return (
                      <Option value={item.value} key={item.value}>
                        <h3><b>>{item.name}</b></h3>
                        <small>{item.desc}</small>
                      </Option>
                    )
                })}
              </ui.Select>
            </ui.Form.Item>
            }


            <ui.Form.Item label={'默认推送帐户'} name={'primary_sender_account'}
                          rules={[{ required: false, message: '默认推送帐户' }]}>
              <ui.Input placeholder={'默认推送帐户'} />
            </ui.Form.Item>


            <ui.Form.Item label={'加友二维码'} name={'qrcode'}
                          rules={[{ required: false, message: '加友二维码' }]}>
              <ui.Input placeholder={'加友二维码'} />
            </ui.Form.Item>

            <ui.Form.Item label={'通道说明'} name={'brief'}
                          rules={[{ required: true, message: '通道说明' }]}>
              <TextArea rows={8} placeholder={'执行器'} />
            </ui.Form.Item>
            <ui.Form.Item>
              <ui.Button htmlType={'submit'} loading={that.state.submitting} type={'primary'} block>立即提交</ui.Button>
            </ui.Form.Item>
          </ui.Form>
        </ui.Modal>
      </div>
    )
  }
}